import { useEffect, useRef, type MutableRefObject } from "react";

export const useIsMounted = (): MutableRefObject<boolean> => {
	const mounted = useRef<boolean>(true);

	useEffect(() => {
		mounted.current = true;
		return () => {
			mounted.current = false;
		};
	}, []);

	return mounted;
};